import { ChevronLeftIcon, ChevronRightIcon, PencilSquareIcon } from '@heroicons/react/24/outline';
import { IconTooltip } from './ui/TooltipCard';

const arrowClass = 'absolute top-1/2 -translate-y-1/2 rounded text-slate-300 hover:text-slate-500 transition focus:outline-none';

function ImagePreviewCarousel({ urls, index, onIndexChange, onManage }) {
  const currentIndex = Math.min(index, urls.length - 1);

  return (
    <div className="relative w-full aspect-video border border-black/20 rounded-lg overflow-hidden flex items-center justify-center p-2">
      {urls.length > 0 ? (
        <>
          <img src={urls[currentIndex]} alt="" className="max-w-full max-h-full object-contain" />
          {urls.length > 1 && (
            <>
              {index > 0 && (
                <button type="button" onClick={() => onIndexChange(index - 1)} className={`${arrowClass} left-1`} aria-label="Previous image">
                  <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              )}
              {index < urls.length - 1 && (
                <button type="button" onClick={() => onIndexChange(index + 1)} className={`${arrowClass} right-1`} aria-label="Next image">
                  <ChevronRightIcon className="h-5 w-5" aria-hidden="true" />
                </button>
              )}
              <span className="absolute bottom-2 left-2 text-xs text-white drop-shadow">
                {currentIndex + 1} / {urls.length}
              </span>
            </>
          )}
        </>
      ) : (
        <span className="text-sm text-slate-400">No images added</span>
      )}
      <div className="absolute bottom-1.5 right-1.5">
        <IconTooltip label="Manage images" position="top-right">
          <button
            type="button"
            onClick={onManage}
            aria-label="Manage images"
            className="group p-0.5 text-secondary-red drop-shadow transition focus:outline-none"
          >
            <PencilSquareIcon className="h-5 w-5 opacity-40 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
          </button>
        </IconTooltip>
      </div>
    </div>
  );
}

export default ImagePreviewCarousel;
